import { Component, ViewChild } from '@angular/core';
import { ApiService } from '../../../../services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CalendarioSpettacolo, CastSpettacolo, GalleriaSpettacolo, PrezzoSpettacolo, Spettacolo, SuggestioneSpettacolo, TimelineSpettacolo } from '../../../../shared/interface';
import { ConfirmationService } from 'primeng/api';
import { ConfirmPopup } from 'primeng/confirmpopup';

@Component({
  selector: 'app-modifica-spettacolo-backoffice',
  templateUrl: './modifica-spettacolo-backoffice.component.html',
  styleUrl: './modifica-spettacolo-backoffice.component.css'
})
export class ModificaSpettacoloBackofficeComponent {

  constructor(private apiService: ApiService, private router: Router, private route: ActivatedRoute, private datePipe: DatePipe, private confirmationService: ConfirmationService) { }

  @ViewChild("deleteSpettacolo") deleteSpettacolo!: ConfirmPopup;

  formSpettacolo!: FormGroup;

  loading: boolean = false;
  carica: boolean = false;

  webshop: boolean = false;
  custom: boolean = false;  
  
  date_calendario: CalendarioSpettacolo[] = [];  
  prezzi: PrezzoSpettacolo[] = [];  
  casts: CastSpettacolo[] = [];  
  immagini?: {img_box: string, img_home: string, img_cover: string};
  timelines: TimelineSpettacolo[] = [];
  galleria: GalleriaSpettacolo[] = [];  
  files_galleria: File[] = [];
  suggeriti: SuggestioneSpettacolo[] = []

  spettacolo?: Spettacolo;
  spettacoli: Spettacolo[] = [];

  minDate: Date | undefined = new Date();

  section: string = 'info';
  
  ngOnInit(): void {    

    this.formSpettacolo = new FormGroup({
      spettacolo: new FormControl(null, Validators.required),
      compagnia: new FormControl(null),
      descrizione: new FormControl(null),
      dal_al: new FormControl(null, Validators.required),
      prenotabile_dal: new FormControl(null),
      prenotabile_dal_orario: new FormControl(null),
      online: new FormControl(null),
      evidenzia: new FormControl(null),
      gratuito: new FormControl(null),
      in_vendita_dal: new FormControl(null),
      in_vendita_dal_data: new FormControl(null),
      soon_in_vendita: new FormControl(null),
      sold_out: new FormControl(null),
      annullato: new FormControl(null),
      webshop: new FormControl(null),
      custom: new FormControl(null),
      link_webshop: new FormControl(null),
      link_custom: new FormControl(null),
      spettacoli_suggeriti: new FormControl(null),
      descrizione_prezzi: new FormControl(null)
    })        

    // Recupero l'id dall'url
    this.route.params.subscribe(params => {
      const id = params['id'];

      this.carica = true;
      // Recupero i dati dello spettacolo
      this.apiService.getSpettacolo(id).subscribe({
        next: (data) => this.spettacolo = data,
        error: (err) => this.router.navigate(['/backoffice/spettacoli']),
        complete: () => {

          this.date_calendario = this.spettacolo?.calendario || [];
          this.prezzi = this.spettacolo?.prezzi || [];
          this.casts = this.spettacolo?.cast || [];
          this.galleria = this.spettacolo?.galleria || [];
          this.suggeriti = this.spettacolo?.suggestioni || [];
          this.timelines = this.spettacolo?.timeline || [];          

          this.webshop = this.spettacolo?.webshop ? true : false;
          this.custom = this.spettacolo?.custom ? true : false;

          this.apiService.getSpettacoli().subscribe({
            next: (data) => this.spettacoli = [...data.filter(spettacolo => spettacolo.id !== this.spettacolo!.id)],
            error: (err) => this.router.navigate(['/backoffice/spettacoli']),
            complete: () => {

              this.carica = false;

              // Aggiorno il form con i dati recuperati
              this.formSpettacolo.patchValue({
                spettacolo: this.spettacolo?.spettacolo,
                compagnia: this.spettacolo?.compagnia,
                descrizione: this.spettacolo?.descrizione,
                dal_al: [new Date(this.spettacolo!.dal), new Date(this.spettacolo!.al)],
                prenotabile_dal: this.spettacolo?.prenotabile_dal ? new Date(this.spettacolo!.prenotabile_dal) : null,
                prenotabile_dal_orario: this.spettacolo?.prenotabile_dal_orario ? new Date(this.datePipe.transform(new Date(), 'yyyy-MM-dd') + " " + this.spettacolo!.prenotabile_dal_orario) : null,
                online: this.spettacolo?.online ? ['online'] : [],
                evidenzia: this.spettacolo?.evidenzia ? ['evidenzia'] : [],
                gratuito: this.spettacolo?.gratuito ? ['gratuito'] : [],
                in_vendita_dal: this.spettacolo?.in_vendita_dal ? ['in_vendita_dal'] : [],
                in_vendita_dal_data: this.spettacolo?.in_vendita_dal_data ? new Date(this.spettacolo!.in_vendita_dal_data) : null,
                soon_in_vendita: this.spettacolo?.soon_in_vendita ? ['soon_in_vendita'] : [],
                sold_out: this.spettacolo?.sold_out ? ['sold_out'] : [],
                annullato: this.spettacolo?.annullato ? ['annullato'] : [],
                webshop: this.spettacolo?.webshop ? ['webshop'] : [],
                custom: this.spettacolo?.custom ? ['custom'] : [],
                link_webshop: this.spettacolo?.link_webshop,
                link_custom: this.spettacolo?.link_custom,
                spettacoli_suggeriti: [...this.suggeriti.map(suggerito => {
                  return this.spettacoli.filter(spettacolo => spettacolo.id == suggerito.id_suggestione)[0]
                })],
                descrizione_prezzi: this.spettacolo?.descrizione_prezzi,
              })

            }
          })

        }
      })
    })

  }

  onCheckBox(value: any, tipo: string) {    
    if (value.length > 0) {
      if (tipo == 'webshop')
        this.webshop = true;
      else
        this.custom = true; 
    } else {
      if (tipo == 'webshop')
        this.webshop = false;
      else
        this.custom = false; 
    }
  }

  onInVenditaDal(value: any) {
    if (value.length > 0) {
      this.formSpettacolo.get('in_vendita_dal_data')?.setValidators(Validators.required);
    } else {
      this.formSpettacolo.get('in_vendita_dal_data')?.clearValidators();
    }

    this.formSpettacolo.get('in_vendita_dal_data')?.updateValueAndValidity();

  }
  
  onPrezziSpettacolo(prezzi: PrezzoSpettacolo[]) {
    this.prezzi = [...prezzi];
  } 

  onDateSpettacolo(date: CalendarioSpettacolo[]) {
    this.date_calendario = [...date];
  }  

  onCastSpettacolo(cast: CastSpettacolo[]) {
    this.casts = [...cast];
  }   
  
  onTimelineSpettacolo(timeline: TimelineSpettacolo[]) {
    this.timelines = [...timeline];
  }   

  onImmaginiSpettacolo(immagini: {img_box: string, img_home: string, img_cover: string}) {
    this.immagini = immagini;
  }

  onGalleriaSpettacolo(data: {galleria: GalleriaSpettacolo[], files: File[]}) {    
    this.galleria = [...data.galleria];
    this.files_galleria = [...data.files];
  }

  // SPETTACOLO
  onOpenDeleteSpettacolo(event: Event) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: "Sei sicuro di voler eliminare lo spettacolo?",
      reject: () => this.confirmationService.close(),
      accept: () => {
        this.apiService.deleteSpettacolo(this.spettacolo!.id).subscribe({
          next: (data) => this.apiService.setSpettacoli(),
          error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
          complete: () => {
            this.confirmationService.close()
            this.router.navigate(['/backoffice/spettacoli']);
            this.apiService.message("success", "Eliminazione", "Lo spettacolo è stato eliminato con successo")
          }
        })
      }
    });
  }

  onDeleteSpettacolo() {
    this.deleteSpettacolo.accept();
  }

  onAnnullaDeleteSpettacolo() {
    this.deleteSpettacolo.reject();
  }
  // SPETTACOLO    
  
  onSubmit() {

    const formData = new FormData();

    let spettacolo = {
      spettacolo: this.formSpettacolo.get('spettacolo')?.value,
      compagnia: this.formSpettacolo.get('compagnia')?.value,
      descrizione: this.formSpettacolo.get('descrizione')?.value,
      dal: this.formSpettacolo.get('dal_al')?.value ? this.datePipe.transform(this.formSpettacolo.get('dal_al')?.value[0], 'yyyy-MM-dd') || null : null,
      al: this.formSpettacolo.get('dal_al')?.value ? this.datePipe.transform(this.formSpettacolo.get('dal_al')?.value[1], 'yyyy-MM-dd') || null : null,
      prenotabile_dal: this.formSpettacolo.get('prenotabile_dal')?.value ? this.datePipe.transform(this.formSpettacolo.get('prenotabile_dal')?.value, 'yyyy-MM-dd') || null : null,
      prenotabile_dal_orario: this.formSpettacolo.get('prenotabile_dal_orario')?.value ? this.datePipe.transform(this.formSpettacolo.get('prenotabile_dal_orario')?.value, 'HH:mm') || null : null,
      online: this.formSpettacolo.get('online')?.value ? (this.formSpettacolo.get('online')?.value.length > 0 ? true : false) : false,
      evidenzia: this.formSpettacolo.get('evidenzia')?.value ? (this.formSpettacolo.get('evidenzia')?.value.length > 0 ? true : false) : false,
      gratuito: this.formSpettacolo.get('gratuito')?.value ? (this.formSpettacolo.get('gratuito')?.value.length > 0 ? true : false) : false,
      in_vendita_dal: this.formSpettacolo.get('in_vendita_dal')?.value ? (this.formSpettacolo.get('in_vendita_dal')?.value.length > 0 ? true : false) : false,
      in_vendita_dal_data: this.formSpettacolo.get('in_vendita_dal_data')?.value ? this.datePipe.transform(this.formSpettacolo.get('in_vendita_dal_data')?.value, 'yyyy-MM-dd') || null : null,
      soon_in_vendita: this.formSpettacolo.get('soon_in_vendita')?.value ? (this.formSpettacolo.get('soon_in_vendita')?.value.length > 0 ? true : false) : false,
      sold_out: this.formSpettacolo.get('sold_out')?.value ? (this.formSpettacolo.get('sold_out')?.value.length > 0 ? true : false) : false,
      annullato: this.formSpettacolo.get('annullato')?.value ? (this.formSpettacolo.get('annullato')?.value.length > 0 ? true : false) : false,
      webshop: this.formSpettacolo.get('webshop')?.value ? (this.formSpettacolo.get('webshop')?.value.length > 0 ? true : false) : false,
      custom: this.formSpettacolo.get('custom')?.value ? (this.formSpettacolo.get('custom')?.value.length > 0 ? true : false) : false,
      link_webshop: this.formSpettacolo.get('link_webshop')?.value,
      link_custom: this.formSpettacolo.get('link_custom')?.value,
      descrizione_prezzi: this.formSpettacolo.get('descrizione_prezzi')?.value,
      spettacoli_suggeriti: this.formSpettacolo.get('spettacoli_suggeriti')?.value ? this.formSpettacolo.get('spettacoli_suggeriti')?.value.map((spettacolo: any, index: number) => { spettacolo.posizione = index; return spettacolo }) : [],
      img_box: this.immagini?.img_box || '',
      img_home: this.immagini?.img_home || '',
      img_cover: this.immagini?.img_cover || ''
    }

    this.loading = true;

    // Aggiorno lo spettacolo
    this.apiService.updateSpettacolo(spettacolo, this.spettacolo!.id).subscribe({
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
      complete: () => {

        // Setto il valore delle date calendario nel formato corretto
        this.date_calendario.map(data => data.data = this.datePipe.transform(data.data, 'yyyy-MM-dd'))

        // Aggiungo la posizione per i prezzi
        this.prezzi.map((prezzo, index) => prezzo.posizione = index);

        // Aggiungo la posizione per i cast
        this.casts.map((cast, index) => cast.posizione = index);

        // Formo gli arrai per l'update o l'aggiunta delle nuove date calendario
        let new_date = this.date_calendario.filter(data => !data.id);
        let update_date = this.date_calendario.filter(data => data.id);

        // Formo gli arrai per l'update o l'aggiunta di nuovi prezzi
        let new_prezzi = this.prezzi.filter(prezzo => !prezzo.id);
        let update_prezzi = this.prezzi.filter(prezzo => prezzo.id);

        // Formo gli arrai per l'update o l'aggiunta di nuovi cast
        let new_cast = this.casts.filter(cast => !cast.id);
        let update_cast = this.casts.filter(cast => cast.id);

        // Aggiungo la posizione per la timeline
        this.timelines.map((timeline, index) => {
          timeline.posizione = index;
          timeline.data = this.datePipe.transform(timeline.data, 'yyyy-MM-dd') || ''
        });

        // Aggiungo la posizione per i file
        this.galleria.map((file, index) => file.posizione = index);
        let update_galleria = this.galleria.filter(file => file.id != 0);

        // Aggiungo anche la posizione ai file
        this.files_galleria.map((file, index) => {
          formData.append('file', file);
          formData.append('posizione', (this.galleria.length + index).toString());
        });

        formData.append('galleria', JSON.stringify(this.galleria.filter(file => file.file_base64)));

        // Aggiorni le date calendario
        this.apiService.updateCalendarioSpettacolo({ calendario: update_date }, this.spettacolo!.id).subscribe({
          error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
          complete: () => {

            // Aggiungo le nuove date calendario
            this.apiService.addCalendarioSpettacolo({ calendario: new_date }, this.spettacolo!.id).subscribe({
              error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
              complete: () => {

                // Aggiorni i prezzi
                this.apiService.updatePrezziSpettacolo({ prezzi: update_prezzi }, this.spettacolo!.id).subscribe({
                  error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
                  complete: () => {

                    // Aggiungo i nuovi prezzi
                    this.apiService.addPrezziSpettacolo({ prezzi: new_prezzi }, this.spettacolo!.id).subscribe({
                      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
                      complete: () => {

                        // Aggiorno i cast
                        this.apiService.updateCastSpettacolo({ casts: update_cast }, this.spettacolo!.id).subscribe({
                          error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
                          complete: () => {

                            // Aggiungo i nuovi cast
                            this.apiService.addCastSpettacolo({ casts: new_cast }, this.spettacolo!.id).subscribe({
                              error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
                              complete: () => {

                                // Aggiungo i file nella galleria
                                this.apiService.addGalleriaSpettacolo(formData, this.spettacolo!.id).subscribe({
                                  error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
                                  complete: () => {

                                    // Aggiorno i file della galleria
                                    this.apiService.updateGalleriaSpettacolo({ galleria: update_galleria }, this.spettacolo!.id).subscribe({
                                      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
                                      complete: () => {

                                        // Aggiorno la timeline
                                        this.apiService.updateTimelineSpettacolo({ timeline: this.timelines }, this.spettacolo!.id).subscribe({
                                          error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
                                          complete: () => {

                                            this.loading = false;                                            
                                            this.apiService.message('success', 'Modifica', "Modifica effettuata con successo!")                                            
                                            this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => { this.router.navigate(['/backoffice/spettacoli/' + this.spettacolo!.id]); });
                                          }
                                        })

                                      }
                                    })
                                  }
                                })
                              }
                            })
                          }
                        })
                      }
                    })
                  }
                })
              }
            })
          }
        })
      }

    })

  }

}